import React, { Component } from "react";
import './NewForm.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Grid, Row, Col, Nav, NavItem, Tab, Panel} from 'react-bootstrap';
import './Patient.css'
import Generals from './Patient/Generals';
import PhotosUpload from './Patient/PhotosUpload';
import MedicalHistory from './Patient/MedicalHistory';
import PickupOrder from './Patient/PickupOrder';
import HistoryAppointment from './Patient/HistoryAppointment';
import PlanningPreference from './Patient/PlanningPreference';
import Parse from 'parse';

class NewForm extends Component {
    currentUser = Parse.User.current();
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            patient: null
        };
    }

    componentDidMount = async () => {
        if(this.currentUser === null){
            console.error('Not user logged');
            this.props.history.push( `/pages/log-out`)
            return;
        }
        const patientId = this.props.match.params.id;
        if(patientId === "0"){
            this.setState({patient:{id: 0}, loading:false});
            return;
        }else{
            const Patient = Parse.Object.extend('Patient');
            const query = new Parse.Query(Patient);
            
            this.setState({loading:true});
            try {
                let patientFounded = await query.get(patientId);
                this.setState({patient: patientFounded, loading:false});
                return;
            } catch (error) {
                this.setState({patient: null, loading:false});                
            }
        }
    }

    patientAddedHandler = (isNew, patient) => {
        if(isNew){
            this.setState({patient:patient});
            this.props.history.push(`/forms/newform/${patient.id}`);
        }
    }
  
    render() {
        const {patient} = this.state;
        let loading = this.state.loading ? 
            <div className="loadingScreen">
                <div className="lds-dual-ring"></div>
            </div> 
            : 
            null;

        if(patient === null){
            return (
                <div className="loadingScreen">
                    <div className="lds-dual-ring"></div>
                </div> 
            )
        }
        
        let name = "Nuevo paciente";
        if(patient !== null && patient.id !== 0){
            name = patient.get("name");
        }
        
        return (
            <Grid>
                {loading}
                <div className="vertical-separator-20px"></div>
                <Row>
                    <Col md={10} mdOffset={1}>
                        <Panel>
                            <Panel.Body>
                                <h3>{name}</h3>

                                <Tab.Container id="tabs-with-icons" defaultActiveKey="info">
                                    <Row className="clearfix patient-form-container">
                                        <Col sm={12}>
                                            {patient.id === 0? 
                                                <Nav bsStyle="tabs">
                                                    <NavItem eventKey="info">
                                                        <i className="fa fa-user"></i><span className="hidden-xs">Datos generales</span>
                                                    </NavItem>
                                                    <NavItem eventKey="medical" className="cursor-disable" disabled>
                                                        <i className="fa fa-user-md"></i><span className="hidden-xs">Historial <span className="hidden-sm">médico</span></span>
                                                    </NavItem>
                                                    <NavItem eventKey="photo" className="cursor-disable" disabled>
                                                        <i className="fa fa-camera"></i><span className="hidden-xs">Fotografías</span>
                                                    </NavItem>
                                                    <NavItem eventKey="appointment" className="cursor-disable" disabled>
                                                        <i className="fa fa-calendar"></i><span className="hidden-xs">Citas</span>
                                                    </NavItem>
                                                    <NavItem eventKey="planningPreference" className="cursor-disable" disabled>
                                                        <i className="fa fa-check-square-o"></i><span className="hidden-xs">Planning</span>
                                                    </NavItem>
                                                    <NavItem eventKey="pickup" className="cursor-disable" disabled>
                                                        <i className="fa fa-truck"></i><span className="hidden-xs">Recolección</span>
                                                    </NavItem>
                                                </Nav>
                                                :
                                                <Nav bsStyle="tabs">
                                                    <NavItem eventKey="info">
                                                        <i className="fa fa-user"></i><span className="hidden-xs">Datos generales</span>
                                                    </NavItem>
                                                    <NavItem eventKey="medical">
                                                        <i className="fa fa-user-md"></i><span className="hidden-xs">Historial <span className="hidden-sm">médico</span></span>
                                                    </NavItem>
                                                    <NavItem eventKey="photo">
                                                        <i className="fa fa-camera"></i><span className="hidden-xs">Fotografías</span>
                                                    </NavItem>
                                                    <NavItem eventKey="appointment">
                                                        <i className="fa fa-calendar"></i><span className="hidden-xs">Citas</span>
                                                    </NavItem>
                                                    <NavItem eventKey="planningPreference" className="cursor-disable">
                                                        <i className="fa fa-check-square-o"></i><span className="hidden-xs">Planning</span>
                                                    </NavItem>
                                                    <NavItem eventKey="pickup">
                                                        <i className="fa fa-truck"></i><span className="hidden-xs">Recolección</span>
                                                    </NavItem>
                                                </Nav>
                                            }
                                        </Col>
                                        <Col sm={12}>
                                            <Tab.Content animation>
                                                <Tab.Pane eventKey="info">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <Generals
                                                                patient={patient}
                                                                patientAdded={this.patientAddedHandler}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="medical">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <MedicalHistory
                                                                patient={patient}
                                                                />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane> 
                                                <Tab.Pane eventKey="photo">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <PhotosUpload
                                                                patient={patient}
                                                                />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane> 
                                                <Tab.Pane eventKey="appointment">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <HistoryAppointment
                                                                patient={patient}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane> 
                                                <Tab.Pane eventKey="planningPreference">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <PlanningPreference
                                                                patient={patient}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane> 
                                                <Tab.Pane eventKey="pickup">
                                                    <Row>
                                                        <Col md={10} mdOffset={1}>
                                                            <PickupOrder
                                                                patient={patient}
                                                                />
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane> 
                                            </Tab.Content>
                                        </Col>
                                    </Row>
                                </Tab.Container>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

export default NewForm;



// WEBPACK FOOTER //
// ./src/views/Forms/NewForm.jsx